import React, {useState} from 'react';
import {Alert, Col, Row} from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import {CardSkeleton} from '../../../shared/ui/LoadingSkeletons';
import {useEdges} from '../context/EdgesContext';
import {updateBalenaStatus} from '../services/edgesApi';
import {useEdgesFilter} from '../hooks/useEdgesFilter';
import {usePagination} from '../hooks/usePagination';
import StatsWidgets from './StatsWidgets';
import EdgesToolbar from './EdgesToolbar';
import EdgeCard from './EdgeCard';
import EdgeTable from './EdgeTable';
import EdgeMap from './EdgeMap';
import Pagination from './Pagination';

const EdgesOverview = () => {
  const {edges, loading, updateEdgeState} = useEdges();
  const [viewMode, setViewMode] = useState('card');

  const {
    displayedEdges,
    searchValue,
    setSearchValue,
    filterStatus,
    setFilterStatus,
    filterLifecycle,
    setFilterLifecycle,
    filterTenant,
    setFilterTenant,
    sortOption,
    setSortOption,
    availableTenants,
    toggleFilter,
    isSelected,
  } = useEdgesFilter(edges);

  const {pagedItems, totalPages, currentPage, setCurrentPage, getPageItems} = usePagination(displayedEdges);

  const handleBalenaUpdate = (id) => updateBalenaStatus(id, updateEdgeState);

  if (loading) {
    return (
      <>
        <div><Skeleton height={38} width={625} borderRadius={4}/></div>
        <div/>
        <Row xs={1} md={2}>
          <CardSkeleton count={10}/>
        </Row>
      </>
    );
  }

  if (!edges.length) {
    return (
      <Alert variant="success">
        Willkommen im Smart Charge Controller Portal!
        <br/><br/>
        Ihnen wurden noch keine Smart Charge Controller zugewiesen. Kontaktieren Sie uns unter{' '}
        <a href="mailto:scc@lehmann.ch">scc@lehmann.ch</a>
      </Alert>
    );
  }

  return (
    <>
      <StatsWidgets edges={edges} filterStatus={filterStatus}/>
      <EdgesToolbar
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        viewMode={viewMode}
        setViewMode={setViewMode}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        filterLifecycle={filterLifecycle}
        setFilterLifecycle={setFilterLifecycle}
        filterTenant={filterTenant}
        setFilterTenant={setFilterTenant}
        sortOption={sortOption}
        setSortOption={setSortOption}
        availableTenants={availableTenants}
        toggleFilter={toggleFilter}
        isSelected={isSelected}
        resultCount={displayedEdges.length}
        currentPage={currentPage}
        totalPages={totalPages}
      />
      {viewMode === 'map' && (
        <Row>
          <EdgeMap edgeData={displayedEdges}/>
        </Row>
      )}
      {viewMode === 'card' && (
        <Row xs={1} md={2}>
          {pagedItems.map((e) => (
            <Col key={e.id} className="p-2">
              <EdgeCard edgeData={e} updateBalenaStatus={handleBalenaUpdate}/>
            </Col>
          ))}
        </Row>
      )}
      {viewMode === 'table' && (
        <Row className="mt-3">
          <Col>
            <EdgeTable
              edgeData={pagedItems}
              updateBalenaStatus={handleBalenaUpdate}
              sortOption={sortOption}
              setSortOption={setSortOption}
            />
          </Col>
        </Row>
      )}
      {viewMode !== 'map' && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          getPageItems={getPageItems}
        />
      )}
    </>
  );
};

export default EdgesOverview;
